/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (ip effect) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		strength: {
			label: 'Style Strength',
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			tip: 'Style transfer strength',
			unit: '%',
			kind: 'range',
			icon: 'mo/palette',
			tooltip: {
				heading: 'Image Style',
				body: 'Apply a visual style from an image',
			},
		},
		asset_id: {
			type: 'string',
			initial: '',
			label: 'Image',
		},
	},
	label: 'Image Style',
	primary: ['strength'],
}
